import Vue from 'vue';
import AuthMixin from "@/mixins/AuthMixin";

// Shut up super old Typescript :'(
declare var TextEncoder: any;

export default Vue.extend({
  name: 'Login',
  data () {
    return {
      state: '',
      codeChallenge: ''
    };
  },
  mixins: [AuthMixin],
  async created() {
    // Start by making sure any old expired tokens are gone.
    await this.$store.dispatch('user/logoutUser');

    // Generate PKCE values for Oauth 2.0 authorization code flow
    this.state = this.makeId(12);
    const codeVerifier = this.makeId(this.getRandomInt(43, 168));
    this.codeChallenge = await this.hashAndEncode(codeVerifier);

    const theMixin = this as any; // Stupid hack for legacy Vue to shut up warnings for stuff in Mixin

    // Put these in our back pocket for later.
    sessionStorage.setItem(theMixin.CODE_VERIFIER_KEY, codeVerifier);
    sessionStorage.setItem(theMixin.STATE_KEY, this.state);

    const baseUrl = `${theMixin.getBaseOauthUrl()}/authorize`;
    const clientId = theMixin.getAppClientId();
    const redirectUrl = theMixin.getRedirectUrl();
    let scopes = 'openid email';
    if (redirectUrl.includes('facility') || redirectUrl.includes('provider') || redirectUrl.includes('localhost')) {
      // Allow them to change their password
      scopes += ' aws.cognito.signin.user.admin';
    }
    window.location.href = `${baseUrl}?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&state=${this.state}&scope=${scopes}&code_challenge_method=S256&code_challenge=${this.codeChallenge}`;
  },
  methods: {
    /*
       * OAuth 2.0 with PKCE https://datatracker.ietf.org/doc/html/rfc7636
       * Must be 45-128 characters comprised of (not including slash / or quote "):  A-Z / a-z / 0-9 / "-" / "." / "_" / "~"
       */
    async hashAndEncode(codeVerifier: string): Promise<string> {
      const sha = await this.digestMessage(codeVerifier);
      // Base64 URL-encoding is special https://datatracker.ietf.org/doc/html/rfc7636#appendix-A Remove padding and replace non-URL-safe chars.
      return btoa(sha).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    },
    /**
     * Doesn't work on IE:
     * SubtleCrypto#digest returns CryptoOperation rather than Promise on IE.
     * TextEncoder isn't supported on IE
     *
     * NMR has confirmed they are okay with dropping IE support.
     * @param message to convert to a SHA256-hashed hex string
     */
    async digestMessage(message: string): Promise<string> {
      // Encode as UTF-8 UInt8Array and Hash
      const hashBuffer = await (crypto.subtle.digest('SHA-256', new TextEncoder().encode(message)) as Promise<any>);
      // Convert to binary array https://stackoverflow.com/a/11562550/1495050
      return String.fromCharCode(...new Uint8Array(hashBuffer as any));
    },
    makeId(length: number): string {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(this.randomRange(0, characters.length));
      }
      return result;
    },
    // Generate a cryptographically-secure random integer r with equal chance in  min <= r < max.
    // https://stackoverflow.com/questions/41437492/how-to-use-window-crypto-getrandomvalues-to-get-random-values-in-a-specific-rang
    randomRange(min: number, max: number): number {
      const range = max - min;
      if (range <= 0) {
        throw new Error('max must be larger than min');
      }
      const requestBytes = Math.ceil(Math.log2(range) / 8);
      if (!requestBytes) { // No randomness required
        return min;
      }
      const maxNum = Math.pow(256, requestBytes);
      const ar = new Uint8Array(requestBytes);

      while (true) {
        window.crypto.getRandomValues(ar);

        let val = 0;
        for (let i = 0; i < requestBytes; i++) {
          val = (val << 8) + ar[i];
        }

        if (val < maxNum - maxNum % range) {
          return min + (val % range);
        }
      }
    },
    getRandomInt(min: number, max: number): number {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/login/Login.ts